import { h } from 'preact'
import classNames from 'classnames'

import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'

export interface TimezoneSelector {
    title: string,
    value: string,
    offset?: string
}

export type TimezoneList = Array<TimezoneSelector>

function normalizeTimezone (timezoneList: TimezoneList, onChange: Function) {
    return timezoneList.map((timezone: TimezoneSelector) => {
        return {
            value: timezone.value,
            title: timezone.title,
            onClick: (e: Event) => onChange((e.target as HTMLElement).getAttribute('value')),
            variant: 'primary'
        }
    })
}

const TimezoneSelector = ({timezones, selected, onChange, error, classes}: {
    timezones: TimezoneList,
    selected: TimezoneSelector | undefined,
    onChange: Function,
    error?: boolean,
    classes?: Array<string>
}) => {
    const normalizedTimezone = timezones && normalizeTimezone(timezones, onChange)

    const DropdownText = () => {
        if(timezones.length === 0) return 'Loading timezones...'
        return selected ?
            <span class='selected'>
            <div class='truncated'>{selected.title}</div>
        </span>
            : 'Choose a timezone'
    }

    const className = classNames({'validation-error': error}, 'timezone-selector qa-timezone-selector', !selected && 'no-timezone-selected-message')

    return <div class='timezone-selector-wrapper'>
        <DropdownControl
            triggerClass={classes && classes.join(' ')}
            align='adjust'
            // @ts-ignore
            trigger={<ButtonControl title={<DropdownText />} class={className} icon={'arrowDropdown'} />}
            items={normalizedTimezone}
            hasSearch={true}
        />
    </div>
}

export default TimezoneSelector
